import { jsx as _jsx } from "react/jsx-runtime";
export var SliderTrack = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, filled = _a.filled, disabled = _a.disabled, style = _a.style;
    return (_jsx("div", { className: "\n      h-1 rounded-full \n      ".concat(filled ? 'bg-vjwPrimary' : 'bg-gray-200', " \n      ").concat(disabled ? 'opacity-50' : '', "\n      ").concat(className, "\n    "), style: style }));
};
